export default __webpack_public_path__ + "static/media/ham-menu-close.26f09e36.svg";